import http from 'services/http'
import { httpSemBaseApi } from 'services/http'

import * as R from 'ramda'

import store from 'store'
import { setSession, clearSession } from 'store/actionCreators/session'
import { setContextParameters } from 'store/actionCreators/contextParameters'
import { setMe, logoutMe, setContext as reduxSetContext } from 'store/actionCreators/me'
import i18n from 'app/i18n'
import config from 'app/config'
import ConvenioService from 'services/convenio'
import InstituicaoService from 'services/instituicao'
import Cookies from 'js-cookie'

const dispatch = R.curry((action, ...args) => store.dispatch(action(...args)))

export const redirectByOrigin = origin => {
  window.location.href = origin
}

const parseBoolean = R.compose(R.equals('true'), R.toLower)

const hasSSO = typeof Cookies.get('isSSO') === 'string' ? parseBoolean(Cookies.get('isSSO')) : 'undefined'

function getCurrentAuthApi() {
  if (hasSSO === 'undefined') {
    return 'authentication'
  }

  return hasSSO ? 'authentication-sso' : 'authentication'
}

const currentAuthApi = getCurrentAuthApi()

export const version = async () =>
  await http.get(
    `/${currentAuthApi}/version`,
    {},
    {
      headers: {
        accept: 'text/plain;charset=UTF-8'
      }
    }
  )

export const logout = async originDomain => {
  const { ok, data } = await http.put(`/${currentAuthApi}/logout`)

  if (ok) {
    Cookies.remove('isSSO')
    !originDomain && dispatch(logoutMe)
    dispatch(clearSession)
    if (!config.project.isVan) {
      window.FreshworksWidget('hide', 'launcher')
    }

    !!originDomain
      ? redirectByOrigin(`${originDomain}/auth/login`)
      : redirectByOrigin(`${window.location.origin}/auth/login`)
  }

  return data
}

let ipClient = {}

export const getClientIp = async () => {
  const link1 = await httpSemBaseApi.get(`https://icanhazip.com/`)

  if (link1.ok && link1.data) {
    return { IPv4: link1.data.trim() }
  }

  const link2 = await httpSemBaseApi.get(`https://api.ipify.org/?format=json`)

  if (link2.ok && link2.data && link2.data.ip) {
    return { IPv4: link2.data.ip }
  }

  const link3 = await httpSemBaseApi.get(`https://geolocation-db.com/json/09ba3820-0f88-11eb-9ba6-e1dd7dece2b8`)

  if (link3.ok && link3.data) {
    return link3.data
  }

  return null
}

export const login = async (email, password, token, project) => {
  const response = await http.post(
    `${currentAuthApi}`,
    {},
    {
      headers: {
        authorization: `Basic ${btoa(`${email.toUpperCase()}:${password.toUpperCase()}`)}`,
        ip: JSON.stringify(ipClient),
        token,
        project,
        locale: i18n.language
      }
    }
  )

  if (response.ok) {
    dispatch(setMe, response.data)
    await session()
  }

  return response
}

export const getContexts = async () => await http.get(`/${currentAuthApi}/contexts`)

const getIsLicitacao = async meData => {
  const { ok, data } = await InstituicaoService.getIsLicitacao()

  if (ok) {
    dispatch(setMe, { ...meData, isLicitacao: data })
  }
}

export const meLoginUnicoSSO = async () => {
  const { ok, data } = await http.post(
    'authentication-sso/me',
    {},
    { headers: { ip: JSON.stringify(ipClient), locale: i18n.language } }
  )

  if (ok) {
    dispatch(setMe, data)
    await session()
    await getIsLicitacao(data)
  } else {
    dispatch(logoutMe)
  }
}

export const getParametrosConvenioById = async ({ context }) => {
  const idConvenio = R.path(['idConvenio'], context)

  if (!idConvenio) return

  const { ok, data } = await ConvenioService.getParametros(idConvenio)

  if (!ok) return

  dispatch(setContextParameters, data)
}

export const me = async () => {
  ipClient = await getClientIp()

  const hasSSOCookie = typeof Cookies.get('isSSO') === 'undefined'

  const { ok, data, status } = await http.post(
    `/${currentAuthApi}/me`,
    {},
    { headers: { ip: JSON.stringify(ipClient), locale: i18n.language } }
  )

  if (hasSSOCookie && status === 401) {
    await meLoginUnicoSSO()
    return
  }

  if (ok) {
    dispatch(setMe, data)
    await getParametrosConvenioById(data)
    await session()
    await getIsLicitacao(data)
  } else {
    dispatch(logoutMe)
  }

  return data
}

export const session = async () => {
  const { ok, data } = await http.get('/contrato/session')

  if (ok) {
    dispatch(setSession, data)
    if (!config.project.isVan) {
      window.FreshworksWidget('show', 'launcher')
    }
  }

  return data
}
export const onLoadWidgetSuporte = () => {
  const scriptWidget = document.createElement('script')
  const scriptFramework = document.createElement('script')
  const inLineScript = document.createTextNode(
    "window.fwSettings={'widget_id':17000000383};!function(){if('function'!=typeof window.FreshworksWidget)" +
      '{var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()'
  )
  scriptWidget.appendChild(inLineScript)

  scriptFramework.type = 'text/javascript'
  scriptFramework.async = true
  scriptFramework.defer = true
  scriptFramework.src = 'https://widget.freshworks.com/widgets/17000000383.js'
  document.body.appendChild(scriptWidget)
  document.body.appendChild(scriptFramework)
}

export const setContext = async contextId => {
  const { ok, status, data } = await http.put(
    `/${currentAuthApi}/contexts/select/${contextId}`,
    {},
    { headers: { ip: JSON.stringify(ipClient) } }
  )

  if (ok) {
    dispatch(reduxSetContext, data)
  }

  return { ok, status, data }
}

export const changePassword = async (uid, password) =>
  await http.put(`/${currentAuthApi}/user/${uid}/changePassword`, password.toUpperCase())

export const getUserDtoInfo = async id => await http.get(`/${currentAuthApi}/user/info/${id}`)

export const forgotPassword = (data, project) =>
  http.post(`/${currentAuthApi}/user/retrieve-pass`, data, {
    headers: {
      project
    }
  })

export const validatePinAndChangePassword = (data, project) =>
  http.post(`/${currentAuthApi}/user/change-password`, data, {
    headers: {
      project
    }
  })

export const redisRefresh = data => http.post(`/${currentAuthApi}/redis-refresh`, data)

export const updateContextConvenioBloqueado = data => {
  dispatch(reduxSetContext, data)
}

export const getTokenObjectStorage = () => {
  return http.get(`/${currentAuthApi}/credentials/object-storage/token`)
}

export const getUserContextCacheValidation = async () =>
  await http.get(`${currentAuthApi}/validar-cache-convenios-usuario`)

export default {
  me,
  version,
  login,
  getContexts,
  setContext,
  logout,
  changePassword,
  getUserDtoInfo,
  forgotPassword,
  validatePinAndChangePassword,
  getClientIp,
  onLoadWidgetSuporte,
  redisRefresh,
  updateContextConvenioBloqueado,
  getTokenObjectStorage,
  session
}
